import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class StickyAddToCart extends HTMLElement {
  #unsubscribe;
  #targetHidden = false;
  #footerVisible = false;
  #targetObserver = null;

  connectedCallback() {
    this.#observeProductForm();
    this.#observeFooter();

    this.#unsubscribe = PubSub.subscribe('variant:change', ({ id, data: { html } }) => {
      if (id !== this.dataset.productId) return;
      this.#handleVariantChange(html);
      this.#observeProductForm();
    });
  }

  disconnectedCallback() {
    this.#unsubscribe();
    this.#targetObserver?.disconnect();
  }

  #handleVariantChange(html) {
    const stickyAddToCart = html.querySelector('sticky-add-to-cart');
    this.innerHTML = stickyAddToCart.innerHTML;
  }

  #observeProductForm() {
    this.#targetObserver?.disconnect();

    const productForm = document.querySelector('product-form');
    if (!productForm) return;

    this.#targetObserver = new IntersectionObserver(([{ isIntersecting }]) => {
      this.#targetHidden = !isIntersecting;
      this.#updateVisibility();
    });

    this.#targetObserver.observe(productForm);
  }

  #observeFooter() {
    const footerBottom = document.querySelector('footer.shopify-section--footer .footer--bottom');
    if (!footerBottom) return;

    new IntersectionObserver(([{ isIntersecting }]) => {
      this.#footerVisible = isIntersecting;
      this.#updateVisibility();
    }).observe(footerBottom);
  }

  #updateVisibility() {
    const show = this.#targetHidden && !this.#footerVisible;
    this.classList.toggle('translate-y-0', show);
    this.classList.toggle('translate-y-full', !show);
    this.classList.toggle('opacity-0', !show);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
